import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ReportNote } from 'src/app/model';
import { ReportProvider } from 'src/app/providers';
import { ToasterService } from 'src/app/services';

@Component({
  selector: 'app-show-note-modal',
  templateUrl: './show-note-modal.component.html',
  styleUrls: ['./show-note-modal.component.scss']
})
export class ShowNoteModalComponent implements OnInit {

  reportVersionId: string = null;

  allNotesList: Array<ReportNote> = [];
  allNoteCount: number = null;
  
  constructor(public showNoteBsModalRef: BsModalRef,
    private reportProvider: ReportProvider,
    private toastr: ToasterService) { }

  ngOnInit(): void {
    if (this.reportVersionId) {
      this.getAllNotes();
    }
  }

  /**
   * @description for get all notes 
   */
  getAllNotes() {
    this.reportProvider.getReportNote(this.reportVersionId).subscribe(res => {
      if (res.success) {
        this.allNotesList = res.result;
        this.allNoteCount = this.allNotesList.length;
        this.allNotesList.sort((a, b) => Number(a.PAGE.ID) - Number(b.PAGE.ID));
      }
    }, err => {
      // Error Handling
    });
  }
  
}
